<script setup lang="ts">
import { NumericValueDto } from '@/api/generator';
import NumberField from '@/components/forms/NumberField/NumberField.vue';
import { computed } from 'vue';
import type { NumericValueFieldProps } from '../types';
import { NumberDisplayOptions } from '../../../utils/numberUtils';

const props = defineProps<NumericValueFieldProps>();

const emits = defineEmits<{
  'update:modelValue': [NumericValueDto];
}>();

const format = computed<NumberDisplayOptions>(() => ({
  fractionDigits: props.modelValue?.decimalPlaces,
  valueType: props.modelValue?.valueType,
}));

function onUpdate(value: number | undefined) {
  if (props.modelValue) {
    emits('update:modelValue', { ...props.modelValue, value });
  }
}
</script>

<template>
  <NumberField
    class="numeric-value-field"
    v-bind="props"
    :modelValue="typeof modelValue?.value === 'number' ? modelValue?.value : undefined"
    :mode="mode"
    :suffix="modelValue?.unitAbbreviation"
    :format="format"
    @update:modelValue="onUpdate"
  />
</template>
